export default __webpack_public_path__ + "static/media/img_5.9e8c5ec2.jpeg";